const storage = {
  get(key, parsed = false, base64 = false) {
    const item = sessionStorage.getItem(key)
    if (item == null) return null

    if (base64) {
      return JSON.parse(atob(item))
    }
    if (parsed) {
      return JSON.parse(item)
    }
    return item
  },
  set(key, value, stringify = false, base64 = false) {
    if (key == null || value == null) return

    if (base64) {
      sessionStorage.setItem(key, btoa(JSON.stringify(value)))
    } else if (stringify) {
      sessionStorage.setItem(key, JSON.stringify(value))
    } else {
      sessionStorage.setItem(key, value)
    }
  },
  delete(key) {
    if (key) {
      sessionStorage.removeItem(key)
    }
  }
}

export default storage
